import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import { formatSimpleCaseStatus } from '@platform-ui-common/utilities/statuses.js';
import useCase from '@platform-ui/case/hooks/useCase.js';
import { Flex, Heading, Text } from '@radix-ui/themes';
import styles from './CaseStatusPanel.module.css';

export default function CaseStatusPanel(): JSX.Element {
  const program = useProgram();
  const { case_ } = useCase();

  return (
    <Flex
      direction="column"
      gap="2"
      px="6"
      py="4"
      width="100%"
      className={styles.caseStatusContainer}
    >
      <Flex justify="between" gap="2">
        <Heading size="5" weight="regular" align="center">
          Case Status
        </Heading>
        <Text size="3">
          <strong>Case ID: {case_?.displayId}</strong>
        </Text>
      </Flex>
      <Flex direction="column" gap="2">
        <Text>
          Your {program.name} application is{' '}
          <strong>{formatSimpleCaseStatus(case_?.status)}</strong>.
        </Text>
      </Flex>
    </Flex>
  );
}
